import React from "react";
import styles from "./Footer.module.css";
import logo from "../../assets/logo-bg-white.png";
import facebook from "../../assets/iconsRedondosSocial/facebook.svg";
import instagram from "../../assets/iconsRedondosSocial/instagram.svg";
import linkedin from "../../assets/iconsRedondosSocial/linkedin.svg";
import whatsapp from "../../assets/iconsRedondosSocial/whatsapp.svg";
import Link from "next/link";
import Image from "next/future/image";

/*<div className={styles.links}>
            <h3>SITE LINKS</h3>
            <div className={styles.sectionLinks}>
            <div>
                <Link href="/">Home</Link>
                <Link href="/sustentabilidade">Sustentabilidade</Link>
                <Link href="/parceiros">Parceiros</Link>
              </div>
              <div>
                <Link href="/empresa">Empresa</Link>
                <Link href="/produtos-e-tecnologia">Produtos e Tecnologia</Link>
                <Link href="/contato">Contato</Link>
              </div>
            </div>
          </div>*/

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className=" container-main">
        <div className={styles.infos}>
          <Link href="/">
            <a>
              <Image
                className={styles.logo}
                src={logo}
                width="460"
                height="200"
                alt="salinas-logo"
              />
            </a>
          </Link>
          <div className={styles.contato}>
            <h3>CONTATO</h3>
            <a href="tel:+551432838344">+55 14 3283-8344</a>
            <a href="mailto:comercial@salinasembalagem.com.br">
              comercial@salinasembalagem.com.br
            </a>
            <span className={styles.contatoDetail}></span>
            <p>
              Rua Benedito Bergamasco, O-35
              <br /> Parque Industrial II Pederneiras - SP
            </p>
          </div>
          <div className={styles.informacoes}>
            <h3>INFORMAÇÕES</h3>
            <Link href="/informacoes/certificacoes">Certificações</Link>
            <Link href="/informacoes/politicas-e-valores">
              Políticas e Valores
            </Link>
            <Link href="/informacoes/responsabilidade-social">
              Responsabilidade Social
            </Link>
          </div>
          
          <div className={styles.links}>
            <h3>DENUNCIA</h3>
            <div className={styles.sectionLinks}>
            <div>
                <Link href="mailto:ouvidoria@salinasembalagem.com.br">ouvidoria@salinasembalagem.com.br</Link>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.subFooter}>
          <div className={styles.iconsGroup}>
            <a
              href="https://pt-br.facebook.com/salinasembalagem/"
              target="_blank"
              rel="noreferrer"
            >
              <Image width="40" height="40" src={facebook} alt="facebook" />
            </a>
            <a
              href="https://www.instagram.com/salinasembalagem/"
              target="_blank"
              rel="noreferrer"
            >
              <Image width="40" height="40" src={instagram} alt="instagram" />
            </a>
            <a
              href="https://www.linkedin.com/in/salinas-embalagem-011768174/"
              target="_blank"
              rel="noreferrer"
            >
              <Image width="40" height="40" src={linkedin} alt="linkedin" />
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=5514982180404"
              target="_blank"
              rel="noreferrer"
            >
              <Image width="40" height="40" src={whatsapp} alt="whatsapp" />
            </a>
          </div>
          <p className={styles.copyRight}>
            © 2022 Cartonagem Salinas Fone: (+55) 14 3283-8344 – Benedito
            Bergamasco, O-35. Pederneiras – SP
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
